import type { StoreActionApi } from 'react-sweet-state';
import { createStore, createHook, createActionsHook } from 'react-sweet-state';

export type HubElementPlaceholderExtensionsState = {
	hubElementPlaceholderLocalId: string | null; // In edit mode defines the localId of the selected hub element placeholder
	hubElementPlaceholderPreviewComponent: React.ReactNode | null; // In edit mode defines the preview component to render within hub element placeholder
};

const initialState: HubElementPlaceholderExtensionsState = {
	hubElementPlaceholderLocalId: null,
	hubElementPlaceholderPreviewComponent: null,
};

// Actions for managing the Custom Site Extensions state that is shared between the extension and the config panel
const actions = {
	setPreviewContentForHubElementPlaceholder:
		(extensionLocalId: string | null, previewComponent: React.ReactNode | null) =>
		({ setState }: StoreActionApi<HubElementPlaceholderExtensionsState>) => {
			setState({
				hubElementPlaceholderLocalId: extensionLocalId,
				hubElementPlaceholderPreviewComponent: previewComponent,
			});
		},
};

const HubElementPlaceholderExtensionsStore = createStore({
	initialState,
	actions,
	name: 'HubElementPlaceholderExtensionsStore',
});

export const useHubElementPlaceholderExtensions = createHook(HubElementPlaceholderExtensionsStore);
export const useHubElementPlaceholderExtensionsActions = createActionsHook(
	HubElementPlaceholderExtensionsStore,
);
